import { Route } from "@angular/router";
import { OfertasPage } from "./ofertas.page";

export const OfertasRouter: Route[] = [
  { path: 'ofertas', component: OfertasPage }
];
